import { render, staticRenderFns } from "./TextSearch.vue?vue&type=template&id=472c09df&"
import script from "./TextSearch.vue?vue&type=script&lang=ts&"
export * from "./TextSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/Users/renan/Fontes/OngFacil/Edital-Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('472c09df')) {
      api.createRecord('472c09df', component.options)
    } else {
      api.reload('472c09df', component.options)
    }
    module.hot.accept("./TextSearch.vue?vue&type=template&id=472c09df&", function () {
      api.rerender('472c09df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/TextSearch.vue"
export default component.exports